// extracted by mini-css-extract-plugin
export var buttons = "_b1-0";
export var buttonsActive = "_b1-h";
export var cancelConfirm = "_b1-1";
export var closeButton = "_b1-2";
export var column = "_b1-3";
export var container = "_b1-4";
export var detailHeader = "_b1-6";
export var detailTitle = "_b1-7";
export var detailsContent = "_b1-5";
export var header = "_b1-8";
export var headerWithClose = "_b1-9";
export var icon = "_b1-a";
export var infoIcon = "_b1-c";
export var informationContainer = "_b1-b";
export var sideDrawer = "_b1-d";
export var sideDrawerOpen = "_b1-e";
export var stickyFooter = "_b1-f";
export var typeOption = "_b1-g";